module.exports = "fragment NoteFragment on Note {\n  id\n  note\n  date {\n    ...CalendarDateFragment\n  }\n}\n"